import React, { useEffect, useState } from 'react';
import { ApiConsumer } from 'api/ApiConsumer';
import Loader from 'components/Loader';
import CoverArtImg from 'components/CoverArtImg';
import { API_ROUTES } from 'routes/api';
import { monthsOfTheYear } from 'api/util';
import { extractChannelLogos, getCurrentMonthNum } from 'api/util';

RecognitionByChannelTable.defaultProps = {
  normaliseData: (res) => res,
};

export function RecognitionByChannelTable({ url = '', normaliseData }) {
  const [data, setData] = useState([]);
  const [channelLogos, setChannelLogos] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    ApiConsumer.get(url)
      .then((res) => {
        setData(normaliseData(res.data));
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));

    ApiConsumer.get(API_ROUTES.BROADCAST.CHANNELS)
      .then((res) => {
        setChannelLogos(extractChannelLogos(res));
      })
      .catch((err) => console.error(err));
  }, [url]);

  if (loading) {
    return <Loader upload_message={'loading'} full_height={true} />;
  }

  const currentMonthNum = getCurrentMonthNum();
  const NUM_COLUMNS_TO_DISPLAY = currentMonthNum + 1;

  return (
    <>
      <section className="grid grid-cols-1 xl:grid-cols-1 2xl:grid-cols-4 gap-4 mt-10">
        <div className="col-span-4">
          <h3 className="mb-2 font-medium profile-overview-title">
            Recognition Performance by Channel (Month vs Month)
          </h3>
          <div className={'rounded shadow mb-10 max-h-96 overflow-y-auto'}>
            <table className="w-full divide-y divide-gray-100">
              <thead className="bg-gray-50">
                <tr>
                  {['Channel / Station', ...monthsOfTheYear]
                    .slice(0, NUM_COLUMNS_TO_DISPLAY)
                    .map((header, index) => (
                      <th
                        key={index}
                        scope="col"
                        className="py-3.5 pl-4 pr-3 text-left text-sm font-medium sm:pl-6"
                      >
                        {header}
                      </th>
                    ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100 bg-white">
                {data.map((channelData, index) => {
                  return (
                    <tr
                      key={index}
                      scope="col"
                      className="py-2 pl-4 pr-3 font-light text-left text-sm sm:pl-6f hover:bg-gray-50 text-gray-600"
                    >
                      {channelData
                        .slice(0, NUM_COLUMNS_TO_DISPLAY)
                        .map((data, index) => {
                          if (index === 0) {
                            return (
                              <td
                                key={index}
                                scope="col"
                                className="py-2 pr-3 text-left text-sm"
                              >
                                <span
                                  className="inline-block"
                                  style={{ minWidth: '100px' }}
                                >
                                  <CoverArtImg
                                    height="12"
                                    imgUrl={channelLogos?.[data?.channel]}
                                  />
                                </span>
                                <span>{data?.channel}</span>
                              </td>
                            );
                          } else {
                            return (
                              <td
                                key={index}
                                scope="col"
                                className="py-3.5 pl-4 pr-3 text-left text-sm sm:pl-6"
                              >
                                {data.performance}
                              </td>
                            );
                          }
                        })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </>
  );
}
